export default __webpack_public_path__ + "static/media/14.289d65cb.png";